(function($) {
  $(document).ready(function() {
    $(".alert-close").on("click", function(ev) {
      $(ev.target).parents(".card").addClass("closed");
    });
  });
})(jQuery);
